export default "__VITE_ASSET__DOYba_Y5__"